import { RTCSessionEvent } from '@wui/jssip/lib/UA'
import mitt from 'mitt'

/**
 * @deprecated
 */
export const eventBus = mitt<{
  removeSession: string
  addSession: RTCSessionEvent
  outgoingCall: RTCSessionEvent
  incomingCall: RTCSessionEvent
  confirmed: string
  hold: string
  unhold: string
  callEnded: string
  callEndedInRoom: string
}>()
